import {
    ChangeDetectionStrategy,
    Component,
    ComponentRef,
    EventEmitter,
    Output,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { IContactSelected } from '@dxp/core/models';
import { VoiceContactVoiceEnquiryComponent } from './voice-enquiry/voice-enquiry.component';
import { VoiceContactVoiceIvrComponent } from './voice-ivr/voice-ivr.component';
import { VoiceContactVoiceTransferComponent } from './voice-transfer/voice-transfer.component';

@Component({
    selector: 'voice-contacts-action',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container #container></ng-container>
    `,
})
export class VoiceContactActionComponent {
    @ViewChild('container', { read: ViewContainerRef, static: true })
    container!: ViewContainerRef;
    componentRef!: ComponentRef<any>;
    selectedComponent: any = null;

    @Output() closeContacts = new EventEmitter<boolean>();
    @Output() disableContacts = new EventEmitter<boolean>();

    loadComponent(
        action: string,
        conversationId: string,
        workItemId: string,
        selected: IContactSelected,
    ) {
        this.container.clear();

        switch (action) {
            case 'voice-transfer':
                this.componentRef = this.container.createComponent(
                    VoiceContactVoiceTransferComponent,
                );
                break;

            case 'voice-enquiry':
                this.componentRef = this.container.createComponent(
                    VoiceContactVoiceEnquiryComponent,
                );
                break;

            case 'voice-ivr':
                this.componentRef = this.container.createComponent(
                    VoiceContactVoiceIvrComponent,
                );
                break;
        }
        this.componentRef.instance.contactSelected = selected;
        this.componentRef.instance.conversationId = conversationId;
        this.componentRef.instance.workItemId = workItemId;
        if (this.componentRef.instance.closeContacts) {
            this.componentRef.instance.closeContacts.subscribe(
                (data: boolean) => {
                    this.closeContacts.emit(data);
                },
            );
        }
        this.componentRef.changeDetectorRef.detectChanges();
    }
}
